import React from 'react'

function DashboardHero() {
  return <>
  <div>Bu Sayfa Private Hero sayfasıdır</div>
  </>
}

export default DashboardHero